import React from "react";
import styled, { css } from "styled-components";
import TextParagraph from "Components/Text/TextParagraph";
import { useLoading } from "Provider/AppProvider";

const Wrapper = styled.div<{ active: boolean }>`
	position: fixed;
	height: ${(props) => `${props.theme.layout.full_height}`};
	width: 100%;
	z-index: ${(props) => props.theme.zIndex.loading};
	left: 0;
	top: 0;
	background-color: ${(props) => props.theme.color.bg};
	${(props) => props.theme.layout.center_flex};
	flex-direction: column;
	transition: ${(props) => props.theme.transition.default};
	transition-delay: 200ms;
	transition-property: opacity;
	${(props) =>
		props.active
			? css`
					transition-delay:0ms;
					transition-duration:0ms;
					opacity: 1;
					${props.theme.event.able}
			  `
			: css`
					opacity: 0;
					${props.theme.event.disable}
			  `};
`;

const PlanetWrapper = styled.div`
	width: ${(props) => `${props.theme.size.loading.planet}px`};
	position: relative;
`;

const Group = styled.div`
	position: relative;
	width: 100%;
	padding-top: 100%;
	animation: move 3s infinite alternate ease-in-out;

	@keyframes move {
		from {
			transform: translateY(8px);
		}
		to {
			transform: translateY(-8px);
		}
	}
`;

const Planet = styled.div`
	/* border: 1px solid white; */
	width: 100%;
	height: 100%;
	left: 0;
	top: 0;
	border-radius: 100%;
	background-color: ${(props) => props.theme.color.bg};
	position: absolute;
	z-index: 1;
	overflow: hidden;
	border: 0.5px solid ${(props) => props.theme.color.gray.light};

	&:after {
		content: "";
		${(props) => props.theme.layout.full_abs};

		/* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#ffffff+0,000000+60&0.3+0,0+42,0+71,1+99 */
		background: -moz-linear-gradient(-45deg, rgba(255, 255, 255, 0.3) 0%, rgba(77, 77, 77, 0) 42%, rgba(0, 0, 0, 0) 60%, rgba(0, 0, 0, 0) 71%, rgba(0, 0, 0, 1) 99%); /* FF3.6-15 */
		background: -webkit-linear-gradient(-45deg, rgba(255, 255, 255, 0.3) 0%, rgba(77, 77, 77, 0) 42%, rgba(0, 0, 0, 0) 60%, rgba(0, 0, 0, 0) 71%, rgba(0, 0, 0, 1) 99%); /* Chrome10-25,Safari5.1-6 */
		background: linear-gradient(
			135deg,
			rgba(255, 255, 255, 0.3) 0%,
			rgba(77, 77, 77, 0) 42%,
			rgba(0, 0, 0, 0) 60%,
			rgba(0, 0, 0, 0) 71%,
			rgba(0, 0, 0, 1) 99%
		); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
		filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#4dffffff', endColorstr='#000000',GradientType=1 ); /* IE6-9 fallback on horizontal gradient */
	}
`;
const Ring = styled.div`
	${(props) => props.theme.layout.center_abs};
	width: calc(100% + 32px);
	height: calc(100% + 32px);
	border-radius: 100%;
	transform: translate(-50%, -50%) rotate3d(1, -1, 0, 65deg);
	z-index: -1;

	border-color: ${(props) => props.theme.color.gray.light};
	border-style: solid;
`;

const RingBack = styled(Ring)`
	border-top-width: 3px;
	border-left-width: 3px;
`;

const RingFront = styled(Ring)`
	border-bottom-width: 3px;
	border-right-width: 3px;
	z-index: 1;
`;

const Shadow = styled.div`
	width: 100%;
	height: ${(props) => `${props.theme.size.loading.planet}px`};

	border-radius: 100%;
	background-color: ${(props) => props.theme.color.black};
	opacity: 0.5;
	transform: scaleY(0.3) scale(1);
	animation: scaleChange 3s infinite alternate ease-in-out;

	@keyframes scaleChange {
		from {
			transform: scaleY(0.3) scale(1);
		}
		to {
			transform: scaleY(0.3) scale(0.8);
		}
	}
`;

const Text = styled(TextParagraph)`
	color: ${(props) => props.theme.color.white};
	text-align: center;
`;

const Loading = () => {
	const { loading: active } = useLoading();

	return (
		<Wrapper active={active}>
			<PlanetWrapper>
				<Group>
					<RingBack />
					<Planet />
					<RingFront />
				</Group>
				<Shadow />
			</PlanetWrapper>
			<Text value={"LOADING . . ."} />
		</Wrapper>
	);
};

export default Loading;
